var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000090269933631461889600000009964992860620335520_);fill:url(#SVGID_00000114034174830535038450000017059096021215270840_);}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000078728173711891630590000016981259117290812802_);fill:url(#SVGID_00000136401181452767176110000010251115942597316784_);}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000143579873871411607930000011191337860904136580_);fill:url(#SVGID_00000164477568528566280570000017514963965509818777_);}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000062902587750056729550000004260356559207060409_);fill:url(#SVGID_00000131339975847297532660000006658680646459759249_);}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000037671218397306998000000011192091005990856073_);fill:url(#SVGID_00000057144291362124014430000017203643101683771539_);}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000138536168549005266240000016804225266976820653_);fill:url(#SVGID_00000060022328864272246210000007401535123506206619_);}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000170968189408438570940000003741023484194240422_);fill:url(#SVGID_00000071524197192147009550000011278176472944704646_);}\n\t\n\t\t.st7{clip-path:url(#SVGID_00000112595090317159911830000011085848984815472533_);fill:url(#SVGID_00000034062492398274983430000014664246312549808051_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M153.9,127.5c0-9.9,8.1-17.9,17.9-17.9c9.9,0,18,8.1,18,17.9c0,9.9-8.1,18-18,18 C161.9,145.4,153.9,137.4,153.9,127.5 M147.2,127.5c0,13.6,11.1,24.7,24.7,24.7c13.6,0,24.7-11.1,24.7-24.7 c0-13.6-11.1-24.7-24.7-24.7C158.2,102.8,147.2,113.9,147.2,127.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042730922622029696990000003563174206698267278_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116213931415822287690000003045599646277055918_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5457,
    y1: 302.756,
    x2: 3.4543,
    y2: 302.756,
    gradientTransform: "matrix(0 89.6343 89.6343 0 -26965.4902 159.2529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 147.2,
    y: 102.8,
    style: {
      clipPath: "url(#SVGID_00000042730922622029696990000003563174206698267278_)",
      fill: "url(#SVGID_00000116213931415822287690000003045599646277055918_)"
    },
    width: 49.3,
    height: 49.3
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000023265475740611580680000017049646429776735658_",
    d: "M85,70.8c-4.7-7.3-2.6-22.1,6.2-44 c18.1,10,29.2,20.3,33,30.7c2.6,7.1,0.7,15.3-4.9,21c0,0-3.4,3.8-7.4,4.8c0,0-0.1,0-0.1,0c-0.2,0.1-2.1,0.6-5,0.6 C101.2,83.9,92.2,81.9,85,70.8 M89.4,18.7c-0.3,0-0.7,0.1-1,0.2c-0.9,0.3-1.6,1-1.9,1.9C75.2,47.5,73,64.5,79.3,74.4 c8.8,13.7,20.3,16.2,27.5,16.2c3.6,0,6.1-0.6,6.7-0.8c6.1-1.6,10.6-6.6,10.6-6.7c7.3-7.4,9.8-18.4,6.3-27.9 c-4.6-12.6-17.8-24.7-39.4-36.1c-0.5-0.2-1-0.4-1.5-0.4H89.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008129866614855345030000003921613209986177169_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023265475740611580680000017049646429776735658_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092446212616370575410000004276063219670850201_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5457,
    y1: 301.9931,
    x2: 3.4543,
    y2: 301.9931,
    gradientTransform: "matrix(0 89.6343 89.6343 0 -26965.4902 159.2529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 18.7,
    style: {
      clipPath: "url(#SVGID_00000008129866614855345030000003921613209986177169_)",
      fill: "url(#SVGID_00000092446212616370575410000004276063219670850201_)"
    },
    width: 61,
    height: 71.8
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000183929561972443333840000015626555406317776773_",
    d: "M123.1,92.6c-1.7,0.7-2.6,2.7-1.9,4.4 c0.7,1.7,2.6,2.5,4.4,1.9c28-11.2,58-10,74.6,3.1c8.7,6.8,12.4,16.2,10.9,27c-0.7,4.9-7.6,13-14.3,20.8 c-10.7,12.4-21.7,25.3-19.4,36.6c1,5,4.6,9,10.6,12c9.8,4.8,20.3-2.5,27.9-7.8c1.8-1.3,3.6-2.7,5.4-4c3.9-3,7.7-5.9,11.8-7.8 c1.9-0.9,4.9-1.8,7.8-1.2c3.3,0.7,6.3,3.5,8.4,7.6c9.3,18.6-8,37.4-28,55c-40.7,35.7-107.2,51.2-150.4,9.5 c-22.4-21.6-24.1-46.6-21.6-63.8c4.8-32.5,29-65.1,60.3-81.2c1.6-0.8,2.3-2.9,1.5-4.5c-0.8-1.6-2.8-2.3-4.5-1.4 c-33.1,17-58.8,51.6-63.9,86.2c-4,26.8,4.2,50.9,23.6,69.6c19.6,18.9,43.6,26.9,68.1,26.9c33,0,66.8-14.5,91.4-36.2 c11.3-9.9,32.6-28.6,32.9-49.2v-0.7c-0.1-4.3-1-8.7-3.2-13.1c-2.9-5.9-7.7-10-13-11.1c-3.7-0.8-7.9-0.2-12,1.6 c-4.9,2.2-9.1,5.4-13.2,8.6c-1.7,1.3-3.4,2.6-5.8,4.3c-6,4.2-14.1,10-20.4,6.8c-4.1-2-6.4-4.4-7-7.3c-1.7-8,8.8-20.2,17.9-30.9 c7.9-9.3,14.8-17.3,15.8-24.2c1.9-13.2-2.9-25-13.4-33.2c-10.2-8-24.8-12.1-40.9-12.1C150.4,84.5,136.5,87.2,123.1,92.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011025523755694158800000009367486577481455511_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183929561972443333840000015626555406317776773_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095310602315143442070000017824658537524187554_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5457,
    y1: 302.4959,
    x2: 3.4543,
    y2: 302.4959,
    gradientTransform: "matrix(0 89.6343 89.6343 0 -26965.4902 159.2529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.6,
    y: 84.5,
    style: {
      clipPath: "url(#SVGID_00000011025523755694158800000009367486577481455511_)",
      fill: "url(#SVGID_00000095310602315143442070000017824658537524187554_)"
    },
    width: 219.9,
    height: 206.7
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000127013058967073665000000001355702584461920955_",
    d: "M67.4,176.1c4.1-11,10.4-20.7,19.4-29.5 c2.8,3.3,4.3,7.5,4.3,11.9c0,10.2-8.3,18.4-18.4,18.4C70.8,176.9,69.1,176.6,67.4,176.1 M84.5,139.4c-11.9,10.9-20,23.2-24.6,37.6 c-0.5,1.6,0.2,3.3,1.7,4c3.5,1.7,7.2,2.5,11,2.5c13.9,0,25.1-11.3,25.1-25.1c0-7.4-3.2-14.3-8.8-19.1c-0.6-0.5-1.4-0.8-2.2-0.8 C86,138.6,85.2,138.9,84.5,139.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063629424105579299680000004083147083061085620_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127013058967073665000000001355702584461920955_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101822316411590526290000014833090786793464723_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5457,
    y1: 301.716,
    x2: 3.4543,
    y2: 301.716,
    gradientTransform: "matrix(0 89.6343 89.6343 0 -26965.4902 159.2529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 59.4,
    y: 138.6,
    style: {
      clipPath: "url(#SVGID_00000063629424105579299680000004083147083061085620_)",
      fill: "url(#SVGID_00000101822316411590526290000014833090786793464723_)"
    },
    width: 38.4,
    height: 45
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000161623401586329922290000005373472993009276310_",
    d: "M65,218.1c-1.4-3.8-1.9-6.8-1.6-10.9 c11.7-2.6,22.5,6.5,22.5,18c0,4.8-1.9,9.3-5.2,12.8C73.7,231.5,67.9,225.4,65,218.1 M59.2,201.4c-1.2,0.4-2.1,1.5-2.2,2.8 c-0.8,6.5-0.3,10.9,1.8,16.4c3.7,9.4,11.1,16.6,19.7,24.4c0.6,0.6,1.4,0.9,2.2,0.9c0.7,0,1.4-0.2,2-0.7c6.3-4.8,9.8-12.1,9.8-19.9 c0-13.9-11.3-25.1-25.1-25.1C64.7,200,61.9,200.4,59.2,201.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170260606717018961130000016884329769921836947_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161623401586329922290000005373472993009276310_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167353874936372577270000011939723857673324961_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5457,
    y1: 301.669,
    x2: 3.4543,
    y2: 301.669,
    gradientTransform: "matrix(0 89.6343 89.6343 0 -26965.4902 159.2529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56.2,
    y: 200,
    style: {
      clipPath: "url(#SVGID_00000170260606717018961130000016884329769921836947_)",
      fill: "url(#SVGID_00000167353874936372577270000011939723857673324961_)"
    },
    width: 36.4,
    height: 45.8
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000120554307127993584020000016676276391548918699_",
    d: "M108.9,254.5c2.3-7.7,9.5-13.3,17.7-13.3 c9.3,0,17,6.9,18.2,16.2c-3,0.6-7.5,1.4-13.1,1.4C125.3,258.7,117.6,257.7,108.9,254.5 M101.7,256.1c-0.2,1.5,0.6,3,2,3.6 c10.7,4.5,20.3,5.8,27.9,5.8c7,0,12.4-1.1,15.7-1.7l1.6-0.3c1.6-0.3,2.8-2.1,2.8-3.8c0-13.9-11.3-25.2-25.1-25.2 C114.2,234.5,103.5,243.8,101.7,256.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093887117060209981520000003186135881358293387_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120554307127993584020000016676276391548918699_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049925989908419683470000003497293260996969403_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5457,
    y1: 302.2514,
    x2: 3.4543,
    y2: 302.2514,
    gradientTransform: "matrix(0 89.6343 89.6343 0 -26965.4902 159.2529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 234.5,
    style: {
      clipPath: "url(#SVGID_00000093887117060209981520000003186135881358293387_)",
      fill: "url(#SVGID_00000049925989908419683470000003497293260996969403_)"
    },
    width: 50.2,
    height: 31
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000107575880868261677360000003400020468957848482_",
    d: "M176.9,228.7c3.1-2.1,6.6-3.1,10.1-3.1 c5.2,0,10.4,2.2,14,6.4c-4.7,4.6-14.4,13.6-31.5,17.5C167.2,241.9,170.1,233.3,176.9,228.7 M173.2,223.1 c-10.3,6.9-14.1,20.6-8.7,31.8c0.6,1.2,1.8,1.9,3,1.9c0.2,0,0.4,0,0.6-0.1c21.9-4.2,33.5-15.8,38.5-20.8l1.2-1.1 c1.2-1.1,1.2-3.4,0.3-4.7c-4.8-7.3-12.8-11.2-21-11.2C182.3,218.9,177.5,220.3,173.2,223.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003790593058651836900000012281403542271572886_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107575880868261677360000003400020468957848482_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148625875435084230470000003375423320516641452_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5457,
    y1: 302.8926,
    x2: 3.4543,
    y2: 302.8926,
    gradientTransform: "matrix(0 89.6343 89.6343 0 -26965.4902 159.2529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 159.1,
    y: 218.9,
    style: {
      clipPath: "url(#SVGID_00000003790593058651836900000012281403542271572886_)",
      fill: "url(#SVGID_00000148625875435084230470000003375423320516641452_)"
    },
    width: 49.9,
    height: 37.9
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000009553058132662705990000000899030096837455005_",
    d: "M117.2,81.2c-1.8,0.6-2.7,2.5-2.2,4.2 c4.4,13.5,13,40.7,21.1,66.8l-28-65.8c-0.7-1.7-2.7-2.5-4.4-1.8c-1.7,0.7-2.5,2.7-1.8,4.4l54.1,127.2c0.5,1.3,1.8,2,3.1,2 c0.4,0,0.8-0.1,1.2-0.2c1.7-0.6,2.6-2.4,2.1-4.1c-0.3-1-31.1-100.3-41-130.7c-0.5-1.4-1.8-2.3-3.2-2.3 C117.9,81,117.5,81.1,117.2,81.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060015762730172615800000001032841024493411773_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009553058132662705990000000899030096837455005_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009584184488017811040000001465731733077600924_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.5457,
    y1: 302.3127,
    x2: 3.4543,
    y2: 302.3127,
    gradientTransform: "matrix(0 89.6343 89.6343 0 -26965.4902 159.2529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    style: {
      stopColor: "#FF00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF00FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 101.3,
    y: 81,
    style: {
      clipPath: "url(#SVGID_00000060015762730172615800000001032841024493411773_)",
      fill: "url(#SVGID_00000009584184488017811040000001465731733077600924_)"
    },
    width: 61.6,
    height: 137.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.a8643fd053cff68feee9f35f0eda7427.svg";
export { ForwardRef as ReactComponent };